module.exports = __webpack_public_path__ + "img/Acacia.4d17f883.jpg";